import React from 'react';
import {observer} from "mobx-react";
import {BettingZoneDrawerMenuItemAccordionArrow} from "./betting-zone.drawer-menu.item-accordion-arrow";
import {BettingZoneDrawerMenuItemPageArrow} from "./betting-zone.drawer-menu.item-page-arrow";

export const BettingZoneDrawerMenuItemArrow = observer(({controller, item, expandedItemId}) => {
  return item.hasItems ? <>
    <BettingZoneDrawerMenuItemAccordionArrow item={item} expandedItemId={expandedItemId}/>
    <BettingZoneDrawerMenuItemPageArrow item={item} controller={controller}/>
  </> : null
});